<payment-list>

    <div class="row">
        <div class="col">
            <nav class="navbar navbar-expand-lg navbar-dark bg-dark-sidebar">
                <div class="container-fluid">
                    <span class="navbar-brand mb-0 h1">Payment Log</span>
                </div>
            </nav>
        </div>
    </div>

    <div class="row">
        <div class="col">

            <table class="table table-striped">

                <thead>
                    <tr>
                        <th scope="col">Date</th>
                        <th scope="col">Amount</th>
                        <th scope="col">Commission ID</th>
                        <th scope="col">Agent</th>
                        <th scope="col">Property</th>
                        <th scope="col">Notes</th>
                        <th scope="col">Recorded</th>
                    </tr>
                </thead>

                <tbody>
                    <tr each="{p in state.payments}">
                        <td>{fmt.datenice(p.date)}</td>
                        <td class="amount">{formatCurrency(p.amount)}</td>
                        <td>
                            <a href="/commission/{p.commission_id}" class="text-decoration-none">
                                #{p.commission_id}
                            </a>
                        </td>
                        <td>
                            <span if="{p.commission && p.commission.staff}">
                                {p.commission.staff.name_display}
                            </span>
                            <span if="{!p.commission || !p.commission.staff}" class="text-muted">-</span>
                        </td>
                        <td>
                            <span if="{p.commission}">
                                {truncate(p.commission.property_address, 30)}
                            </span>
                            <span if="{!p.commission}" class="text-muted">-</span>
                        </td>
                        <td>
                            <span if="{p.notes}" title="{p.notes}">{truncate(p.notes, 25)}</span>
                            <span if="{!p.notes}" class="text-muted">-</span>
                        </td>
                        <td class="text-muted">{fmt.datetime(p.CreatedAt)}</td>
                    </tr>
                    <tr if="{state.payments.length === 0}">
                        <td colspan="7" class="text-center text-muted py-4">No payments recorded yet</td>
                    </tr>
                </tbody>

            </table>

        </div>
    </div>

    <style>
        .amount {
            font-weight: bold;
            color: #198754;
        }
    </style>

    <script>

        import { api_get } from '../../lib/api.js';
        import currency from 'currency.js';

        export default {
            state: {
                payments: []
            },
            onMounted() {
                this.loadPayments();
            },
            formatCurrency(value){
                return currency(value).format();
            },
            truncate(str, len){
                if(!str) return '';
                if(str.length <= len) return str;
                return str.substring(0, len) + '...';
            },
            loadPayments(){
                api_get('commission/payments').then((res)=>{
                    if(res.status == 200){
                        this.update({
                            payments: res.data || []
                        });
                    }
                }).catch((err)=>{
                    console.error('Error loading payments:', err);
                });
            }
        }

    </script>
</payment-list>
